var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5797 16.9766V19.0066C11.5797 20.7266 9.9797 22.1166 8.0097 22.1166C6.0397 22.1166 4.42969 20.7266 4.42969 19.0066V16.9766C4.42969 18.6966 6.0297 19.9166 8.0097 19.9166C9.9797 19.9166 11.5797 18.6866 11.5797 16.9766Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5779 14.2289C11.5779 14.7289 11.4379 15.1889 11.1979 15.5889C10.6079 16.5589 9.39792 17.1689 7.99792 17.1689C6.59792 17.1689 5.38791 16.5489 4.79791 15.5889C4.55791 15.1889 4.41797 14.7289 4.41797 14.2289C4.41797 13.3689 4.81795 12.5989 5.45795 12.0389C6.10795 11.4689 6.99792 11.1289 7.98792 11.1289C8.97792 11.1289 9.86794 11.4789 10.5179 12.0389C11.1779 12.5889 11.5779 13.3689 11.5779 14.2289Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5797 14.2272V16.9772C11.5797 18.6972 9.9797 19.9172 8.0097 19.9172C6.0397 19.9172 4.42969 18.6872 4.42969 16.9772V14.2272C4.42969 12.5072 6.0297 11.1172 8.0097 11.1172C8.9997 11.1172 9.88973 11.4672 10.5397 12.0272C11.1797 12.5872 11.5797 13.3672 11.5797 14.2272Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8283 11.0864V13.1464C22.8283 13.6964 22.3883 14.1464 21.8283 14.1664H19.8683C18.7883 14.1664 17.7983 13.3764 17.7083 12.2964C17.6483 11.6664 17.8883 11.0764 18.3083 10.6664C18.6783 10.2864 19.1883 10.0664 19.7483 10.0664H21.8283C22.3883 10.0864 22.8283 10.5364 22.8283 11.0864Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.82812 10.6172V8.61719C2.82812 5.89719 4.46813 3.99719 7.01813 3.67719C7.27813 3.63719 7.54812 3.61719 7.82812 3.61719H16.8281C17.0881 3.61719 17.3381 3.62718 17.5781 3.66718C20.1581 3.96718 21.8281 5.87719 21.8281 8.61719V10.0672H19.7481C19.1881 10.0672 18.6781 10.2872 18.3081 10.6672C17.8881 11.0772 17.6481 11.6672 17.7081 12.2972C17.7981 13.3772 18.7881 14.1672 19.8681 14.1672H21.8281V15.6172C21.8281 18.6172 19.8281 20.6172 16.8281 20.6172H14.3281",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/finance.5a5ffd94.svg";
export { ForwardRef as ReactComponent };